import { fireSettingsChange, GlobalSettingsKeys } from '@sas/nova-commons/components/Settings';
import { BehaviorSubject } from 'rxjs';
import { formatterLocale$ } from './locale';
import { useBehaviorSubjectValue } from './utils';
import { setFormatLocale as setLTJSFormatLocale } from '@sas-dvr/ltjs-commons/ltjsUtil';
import { whenInitialized } from '@sas-dvr/ltjs-commons/ltjsEnvironment';
export const honorLocalFormatSettings$ = new BehaviorSubject(false);
let currentFormatterLocale = null;
let formatterLocaleSubscription = undefined;
/**
 * @internal
 */
export function setHonorLocalFormatSettings(value) {
    if (value) {
        formatterLocaleSubscription =
            formatterLocaleSubscription !== null && formatterLocaleSubscription !== void 0 ? formatterLocaleSubscription : formatterLocale$.subscribe((locale) => {
                if (currentFormatterLocale !== locale) {
                    whenInitialized().then(() => setLTJSFormatLocale(locale));
                    fireSettingsChange([
                        {
                            key: GlobalSettingsKeys.FORMAT_LOCALE_KEY,
                            value: locale || undefined,
                            oldValue: currentFormatterLocale || undefined,
                        },
                    ]);
                    currentFormatterLocale = locale;
                }
            });
    }
    else {
        formatterLocaleSubscription === null || formatterLocaleSubscription === void 0 ? void 0 : formatterLocaleSubscription.unsubscribe();
        formatterLocaleSubscription = undefined;
    }
    honorLocalFormatSettings$.next(!!value);
}
export function getHonorLocalFormatSettings() {
    return honorLocalFormatSettings$.getValue();
}
export function useHonorLocalFormatSettings() {
    return useBehaviorSubjectValue(honorLocalFormatSettings$);
}
